"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadLocationIdResponse = exports.BadLocationIdResponseSchema = exports.UpcomingHearingConflictResponse = exports.UpcomingHearingConflictResponseSchema = exports.UpcomingHearingUpdate = exports.UpcomingHearingUpdateSchema = exports.UpcomingHearing = exports.UpcomingHearingSchema = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const refine_1 = require("../util/refine");
const case_schemas_1 = require("./case.schemas");
const joda_schemas_1 = require("./joda.schemas");
exports.UpcomingHearingSchema = zod_1.default.object({
    id: zod_1.default.string().uuid(),
    courtSystemId: zod_1.default.string().uuid(),
    locationId: zod_1.default.string().uuid(),
    caseId: zod_1.default.string().uuid(),
    date: joda_schemas_1.LocalDateSchema,
    title: case_schemas_1.CaseTitleSchema.nullable(),
    caseReference: case_schemas_1.CaseReferenceSchema,
});
exports.UpcomingHearing = exports.UpcomingHearingSchema.refine((refine_1.is));
exports.UpcomingHearingUpdateSchema = exports.UpcomingHearingSchema.omit({ caseId: true, courtSystemId: true });
exports.UpcomingHearingUpdate = exports.UpcomingHearingUpdateSchema.refine((refine_1.is));
exports.UpcomingHearingConflictResponseSchema = zod_1.default.object({
    type: zod_1.default.literal('UpcomingHearingConflict'),
    error: zod_1.default.literal('An upcoming hearing with the same case reference, location, date and court system already exists'),
    existingUpcomingHearingId: zod_1.default.string().uuid(),
});
exports.UpcomingHearingConflictResponse = exports.UpcomingHearingConflictResponseSchema.refine((refine_1.is));
exports.BadLocationIdResponseSchema = zod_1.default.object({
    type: zod_1.default.literal('BadLocationId'),
    error: zod_1.default.literal("The provided location ID doesn't exist in the court system."),
});
exports.BadLocationIdResponse = exports.BadLocationIdResponseSchema.refine((refine_1.is));
